module.exports = __webpack_public_path__ + "static/img/install-authenticator.06432dea.svg";